import {useEffect,useState,useRef} from 'react'
import {Box,Typography,Button,CircularProgress, IconButton} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import UserInput from '../Components/UserInput';
import AcceptedDialog from '../Components/AcceptedDialog'
import { PieChart } from '@mui/x-charts/PieChart';
import { Gauge,gaugeClasses } from '@mui/x-charts/Gauge';
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import {Snackbar} from '@mui/material';
import { add_reports } from '../Redux/reportsSlice'
import { ArrowBack } from '@mui/icons-material'
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts'

const TestReport = ()=>{

const data = useSelector(state => state?.test.test);
const user = useSelector(state => state?.auth.user);
const [refreshing,setRefreshing] = useState(false)
const [screening,setScreening] = useState(false)
const [printing,setPrinting] = useState(false)
const [showModal,setShowModal] = useState(false)
const [message,setMessage] = useState('')
const [open,setOpen] = useState(false)
const [testData,setTestData] = useState(null)
const [accepted,setAccepted] = useState(0)
const [acceptedReports,setAcceptedReports] = useState([])
const [finishedTest,setFinishedTest] = useState(0)
const [haveHalf,setHaveHalf] = useState([])
const theme = useTheme() 
const navigate = useNavigate()
const [score,setScore] = useState(50)
const componentRef = useRef(null);
const [capturedImage, setCapturedImage] = useState(null);
const dispatch = useDispatch()


const handleSnackbarClose = ()=>{
	setOpen(false)
}
async function get_data(text) {
try{
	
	const send_data = {
		id:data.id
	}
	
	const getData = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-data/`,send_data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${user?.accessToken}`
              }
       }).catch(err=>console.log(err))
	
	if (getData?.data.success == true && getData.status == 200) {
		setTestData(getData?.data?.data)
		setHaveHalf(getData?.data?.data.reports.filter((item)=>item.score >= score))
	
		const finishedData = getData?.data?.data.users?.filter((item)=>item?.hasFinished == true)
		setFinishedTest(finishedData.length <= 1 ? 0 : finishedData.length-1)
	
	}else{ 
		console.log(getData?.data.data.reports)
	}
	}catch(err){
		console.log(err)
	}
}
	
async function get_accepted() {
	try{
	
		const send_data = {
			id:data.id
		}
		
		const getAccepted = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-accepted/`,send_data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${user?.accessToken}`
              }
       }).catch(err=>console.log(err))
		
		if (getAccepted?.data.success == true && getAccepted.status == 200) {
			setAccepted(getAccepted?.data.reports.length)
			setAcceptedReports(getAccepted?.data.reports)
		}
	
	}catch(err){
		console.log(err)
	}
}

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
	documentTitle: `ItestReport_(${data?.name})`,
	removeAfterPrint: true,
  });

async function handleScreenShot (){
    if (componentRef.current) {
		setScreening(true)
		const element = componentRef.current;
		const canvas = await html2canvas(element);
		const imageData = canvas.toDataURL('image/png').replace('data:image/png;base64,', '');
		const imageBlob = new Blob([atob(imageData)], { type: 'image/png' });
		console.log(imageData )

		const link = document.createElement('a');
		link.href = URL.createObjectURL(imageBlob);
		link.download = `ItestReport_screenshot(${data?.name}).png`; 

		link.click();
		URL.revokeObjectURL(link.href);
		setScreening(false)
    }
  };
	
async function handleAccept(email) {
	try{
		const send_data = {
			id:data.id,
			email:email
		}
	
	const setPass = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}set-accept/`,send_data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${user?.accessToken}`
              }
       }).catch(err=>console.log(err))
	
	if (setPass?.data.success == true && setPass.status == 200) {
		
		const newAccepted = acceptedReports.filter((item)=>item.email !== email)
		setAcceptedReports(newAccepted)
		setMessage("participant has been removed")
		setOpen(true)
	}else{
		setMessage(setPass.data.message)
		setOpen(true)
	}
	
	}catch(err){
		console.log(err)
	}
}

useEffect(()=>{
	get_data()
	get_accepted()
},[score])

// useEffect(()=>{
// if (data?.email !== user?.email) {
// 	navigate("/home/dashboard")
// }
// },[])



  const years = [
	new Date(2024, 6, 1),
	new Date(2024, 5, 4),
	new Date(2024, 8, 1)
  ];
  
  
  const testsDat = [
	261, 257, 257
  ];
  
  const partici = [
	253, 267, 273
  ];
	
const onRefresh = async ()=>{
try{
	setRefreshing(true)
	await get_data()
	await get_accepted()
	setRefreshing(false)
}catch(err){
	console.log(err)
}
}

	return(
	<Box style={{width:"100%",height:"100%"}}>
		<Header>
			<Breadcrumbs aria-label="breadcrumb">
				<Typography sx={{fontSize:12,color:"gray"}}> Dashboard / assessment info </Typography>
				<Typography sx={{fontSize:12,color:"gray"}}> assessment report</Typography>
			</Breadcrumbs>			
		</Header>
		<Snackbar 
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}} 
			message={message} 
			onClose={handleSnackbarClose} 
			open={open} 
			autoHideDuration={2000}
		/>
		<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="flex-start" pt={1} >
			<IconButton sx={{marginRight:{xs:0,md:4}}} onClick={(e)=>{
				e.preventDefault()
				navigate("/testInfo")
			}}>
				<ArrowBack fontSize='small' sx={{color:"gold"}}/>
			</IconButton>
			<Button onClick={(e)=>{
				e.preventDefault()
				setShowModal(true)
			}} sx={{background:"gold",color:"black",height:30,fontSize:10,fontFamily:"dinofans",margin:1,padding:1}}>
				View all accepted
			</Button>
			<Button onClick={async (e)=>{
				e.preventDefault()
				await handleScreenShot()
			}} sx={{background:"maroon",color:"white",height:30,fontSize:10,fontFamily:"dinofans",margin:1,padding:1}}>
				{
					screening ? <CircularProgress size={15} sx={{color:"wite"}}/> : "ScreenShot"
				}
			</Button>
			<Button onClick={async (e)=>{
					e.preventDefault()
					setPrinting(true)
					await handlePrint(null, () => componentRef.current);
					setPrinting(false)
				}} sx={{background:"white",color:"maroon",height:30,fontSize:10,fontFamily:"dinofans",margin:1,padding:1}}>
				{
					printing ? <CircularProgress size={15} sx={{color:"wite"}}/> : "Print"
				}
			</Button>			
		</Box>
		<Box sx={{background:"#100101"}} display="flex" flexWrap="wrap" justifyContent="center" pt={1} ml={printing ? 5 : 2} m={1} mr={2}  ref={componentRef}>
		<Box sx={{width:{xs:"95%",md:"45%"},height:400,margin:1,borderRadius:2}}>
				<Box sx={{borderRadius:2,padding:2,width:"95%"}}>
					<Typography color="gold" fontWeight={500} sx={{fontSize:13,marginBottom:1}}>
						Participants with {score} % or more / Total of participants
					</Typography>
					<Typography  fontWeight={500} sx={{fontFamily:"dinofans",fontSize:15}}>
						{haveHalf?.length} / {testData?.users.length}
					</Typography>
					{
						(!printing && !screening) && (
							<Button onClick={(e)=>{
								e.preventDefault()
								dispatch(add_reports(haveHalf))
								navigate(`/checkPart`)
							}} sx={{background:"#fff",color:"black",width:80,height:30,fontSize:12,fontFamily:"dinofans",marginTop:1}}>
								View
							</Button>							
						)
					}
				</Box>
				<PieChart
					series={[
						{
						data: [
							{ id: 0, value: (haveHalf?.length || 0), label: 'particip' },
							{ id: 1, value: testData?.users.length, label: 'Total' },
						],
						},
					]}
					width={300}
					height={150}
				/>
				{
					(!printing && !screening) && (
						<UserInput
							setInput={setScore}
							input={score}
							label="score"
						/>							
					)
				}
			</Box>
			<Box sx={{width:{xs:"95%",md:"45%"},margin:1,background:"#100101",borderRadius:2}}>
				<Box sx={{borderRadius:2,padding:2,width:"95%",marginBottom:2}}>
					<Typography color="gold" fontWeight={500} sx={{fontSize:13,marginBottom:1}}>
						Total of cancelled  assessments / Total of assessments (participants)
					</Typography>
					<Typography  fontWeight={500} sx={{fontFamily:"dinofans",fontSize:15}}>
						{finishedTest} / {testData?.users.length}
					</Typography>
				</Box>
				<PieChart
					series={[
						{
						data: [
							{ id: 0, value: (finishedTest || 0), label: 'particip' },
							{ id: 1, value: testData?.users.length, label: 'Total' },
						],
						},
					]}
					width={300}
					height={150}
				/>
			</Box>
			<Box sx={{width:{xs:"95%",md:"45%"},margin:1,background:"#100101",borderRadius:2}}>
				<Box sx={{borderRadius:2,padding:2,width:"95%",marginBottom:2}}>
					<Typography color="gold" fontWeight={500} sx={{fontSize:13,marginBottom:1}}>
						Total of participants without an account / Total of participants
					</Typography>
					<Typography  fontWeight={500} sx={{fontFamily:"dinofans",fontSize:15}}>
						{haveHalf?.length || 0} / {testData?.users.length}
					</Typography>
				</Box>
				<PieChart
					series={[
						{
						data: [
							{ id: 0, value: (haveHalf?.length || 0), label: 'particip' },
							{ id: 1, value: testData?.users.length, label: 'Total' },
						],
						},
					]}
					width={300}
					height={150}
				/>
			</Box>
			<Box sx={{width:{xs:"95%",md:"45%"},margin:1,background:"#100101",borderRadius:2}}>
				<Box sx={{borderRadius:2,padding:2,width:"95%",marginBottom:2}}>
					<Typography color="gold" fontWeight={500} sx={{fontSize:13,marginBottom:1}}>
						Total of cancelled  assessments / Total of assessments (participants)
					</Typography>
					<Typography  fontWeight={500} sx={{fontFamily:"dinofans",fontSize:15}}>
						{finishedTest} / {testData?.users.length}
					</Typography>
				</Box>
				<LineChart
					xAxis={[
						{
						id: 'Field',
						data: years,
						scaleType: 'time',
						valueFormatter: (date) => date.getFullYear().toString(),
						},
						
					]}
					series={[
						{
						id: 'Test',
						label: 'Total of Tests',
						data: testsDat,
						stack: 'total',
						area: true,
						showMark: false,
						},
						{
						id: 'Participant',
						label: 'Total of particip',
						data: partici,
						stack: 'total',
						area: true,
						showMark: false,
						},
					]}
					sx={{fontSize:10}}
					width={250}
					height={350}
					margin={{ left: 70 }}
				/>
			</Box>
		</Box>
		<AcceptedDialog visible={showModal} setVisible={setShowModal} data={acceptedReports}/>
	</Box>
	)

	}

	export default TestReport